/* ==========================================================================
   OBSIDIAN CUSTOM — « Voir plus » collections (spec 2026-08-06)
   Le bouton est un vrai lien <a href="?page=N"> : crawlable, fonctionnel
   sans JS. Ici on l'intercepte : fetch de la page suivante via la Section
   Rendering API, append des cartes, remplacement du bouton, et réécriture
   d'URL (history.replaceState) pour que le bouton retour ramène à la bonne
   page (motif Skechers relevé par Baymard).
   Délégation sur document : survit aux re-rendus des facettes.
   Le MutationObserver d'obsidian-color-switch.js ré-applique le toggle
   Gold/Titane aux cartes ajoutées — aucun couplage nécessaire.
   ========================================================================== */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-obsidian-load-more]') : null;
    if (!btn) return;

    // Clic modifié (nouvel onglet / fenêtre) ou déjà géré : laisser le navigateur faire.
    if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;

    e.preventDefault();
    if (btn.hasAttribute('data-olm-loading')) return;
    btn.setAttribute('data-olm-loading', '');
    btn.classList.add('is-loading');

    var sectionEl = btn.closest('.shopify-section');
    var sectionId = sectionEl && sectionEl.id ? sectionEl.id.replace(/^shopify-section-/, '') : '';
    if (!sectionId) { window.location.href = btn.href; return; }

    var url = new URL(btn.href, window.location.origin);
    url.hash = '';
    url.searchParams.set('section_id', sectionId);

    fetch(url.toString())
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        // Course facettes : si le bouton d'origine n'est plus dans le DOM,
        // la grille a été re-rendue entre-temps — on abandonne ce fetch.
        if (!btn.isConnected) return;

        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newList = doc.querySelector('#collection .product-list');
        var curList = document.querySelector('#collection .product-list');
        if (!newList || !curList) { window.location.href = btn.href; return; }

        // Les cartes arrivent avec reveal-on-scroll : l'observer d'animation du
        // thème est déjà initialisé, on retire l'attribut pour éviter des
        // cartes restées invisibles.
        var reveals = newList.querySelectorAll('[reveal-on-scroll]');
        for (var i = 0; i < reveals.length; i++) reveals[i].removeAttribute('reveal-on-scroll');

        while (newList.firstChild) curList.appendChild(newList.firstChild);

        var wrapper = btn.closest('[data-obsidian-load-more-wrapper]');
        var newWrapper = doc.querySelector('[data-obsidian-load-more-wrapper]');
        if (wrapper) {
          if (newWrapper) wrapper.replaceWith(newWrapper);
          else wrapper.remove();
        }

        var clean = new URL(btn.href, window.location.origin);
        clean.hash = '';
        history.replaceState(history.state, '', clean.toString());
      })
      .catch(function () {
        window.location.href = btn.href;
      });
  });

  /* --- Auto-chargement des pages précédentes ---------------------------------
     Retour navigateur sur ?page=N sans bfcache : le serveur ne rend que la
     page N. On récupère les pages 1..N-1 (Section Rendering API) et on les
     insère au-dessus, dans l'ordre, en préservant la position visuelle.
     Pas de maximum : N-1 fetches séquentiels, quel que soit N. */
  function autoloadPreviousPages() {
    var page = parseInt(new URLSearchParams(window.location.search).get('page'), 10);
    if (!page || page <= 1) return;

    var curList = document.querySelector('#collection .product-list');
    if (!curList) return;

    var sectionEl = curList.closest('.shopify-section');
    var sectionId = sectionEl && sectionEl.id ? sectionEl.id.replace(/^shopify-section-/, '') : '';
    if (!sectionId) return;

    var insertRef = curList.firstElementChild;
    var chain = Promise.resolve();

    for (var p = 1; p < page; p++) {
      (function (pageNum) {
        chain = chain.then(function () {
          var url = new URL(window.location.href);
          url.searchParams.set('page', pageNum);
          url.searchParams.set('section_id', sectionId);
          url.hash = '';

          return fetch(url.toString())
            .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
            .then(function (html) {
              if (!curList.isConnected) return; // facettes re-rendues entre-temps : on abandonne

              var doc = new DOMParser().parseFromString(html, 'text/html');
              var newList = doc.querySelector('#collection .product-list');
              if (!newList) return;

              var reveals = newList.querySelectorAll('[reveal-on-scroll]');
              for (var i = 0; i < reveals.length; i++) reveals[i].removeAttribute('reveal-on-scroll');

              var before = insertRef ? insertRef.getBoundingClientRect().top : 0;
              while (newList.firstChild) curList.insertBefore(newList.firstChild, insertRef);
              if (insertRef) {
                var delta = insertRef.getBoundingClientRect().top - before;
                if (delta) window.scrollBy(0, delta);
              }
            });
        });
      })(p);
    }

    chain.catch(function () { /* échec réseau : la grille reste celle de la page N */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoloadPreviousPages);
  } else {
    autoloadPreviousPages();
  }
})();
